import { render, staticRenderFns } from "./PointLogItem.vue?vue&type=template&id=3c95a20f&scoped=true&"
import script from "./PointLogItem.vue?vue&type=script&lang=js&"
export * from "./PointLogItem.vue?vue&type=script&lang=js&"
import style0 from "./PointLogItem.vue?vue&type=style&index=0&id=3c95a20f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c95a20f",
  null
  
)

export default component.exports